/**
 * 描述：租户管理--信息源订阅设置--微博爆料
 * 日期：2018-5-3
 * 作者：gao_kaizhi
 */
'use strict';
angular.module("weiboDiscloseModule", ["newWeiboDiscloseModule"])
    .controller("weiboDiscloseCtrl", ["$scope", "$q", "$filter", "tManageMentService", "modalDialog", "trsHttpService", "$state", "$modal", "trsspliceString", function($scope, $q, $filter, tManageMentService, modalDialog, trsHttpService, $state, $modal, trsspliceString) {
        initStatus();
        initData();
        /** [initStatus description: 初始化状态] */
        function initStatus() {
            $scope.page = {
                PAGESIZE: 20,
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGECOUNT: 1
            };
            $scope.data = {
                copyCurrPage: 1,
                RregionData: "",
                selectedArray: [],
                searchword: ""
            };
        }
        /** [initData description： 初始化数据] */
        function initData() {
            requestData();
        }
        /**
         * [查询微博爆料配置列表]
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_tenant",
                methodName: "queryMicroBlogBursts",
                SEARCHVALUE: $scope.data.searchword,
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.dataList = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.selectedArray = [];
            });
        }
        /** [initData description：新增加微博爆料] */
        $scope.newItem = function() {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/tenantManageMent/infoSourceSetting/weiboDisclose/new/newWeiboDisclose_tpl.html",
                windowClass: 'new-weibo-window',
                backdrop: false,
                controller: "newWeiboDiscloseCtrl",
                resolve: {
                    params: function() {
                        return {};
                    }
                }
            });
            modalInstance.result.then(function(result) {
                requestData();
            },function(){
                requestData();
            });
        };
        $scope.pageChanged = function() {
            requestData();
        };
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                requestData();
            }
        };
        $scope.chooseItem = function(id) {
            if (angular.isUndefined(id)) {
                if ($scope.data.selectedArray.length == $scope.dataList.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = trsspliceString.spliceString($scope.dataList, "TENANTMICROBLOGBURSTID", ",").split(",");
                }
                return;
            }
            var ext = $scope.data.selectedArray.indexOf(id);
            if (ext == -1) {
                $scope.data.selectedArray.push(id);
            } else {
                $scope.data.selectedArray.splice(ext, 1);
            }
        };
        $scope.deleteItem = function(item) {
            var params = {
                    serviceid: "mlf_tenant",
                    methodName: "deleteMicroBlogBursts",
                    microBlogBurstIds:""
                };
            if (angular.isDefined(item)) {
                params.microBlogBurstIds=item.TENANTMICROBLOGBURSTID;
                modalDialog.confirmModal("删除微博", "确定删除" + item.MICROBLOGACCOUNT + "吗？", deleteItem);
            }else{
                params.microBlogBurstIds=$scope.data.selectedArray.join(",");
                modalDialog.confirmModal("删除微博", "确定删除所选微博吗？", deleteItem);
            }
            function deleteItem() {                
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType("", "删除成功", "success", false);
                    requestData();
                });
            }
        };
    }]);